import { cn, Heading } from '@quickmd-llc/design-system'
import React from 'react'

type Props = {
  icon: React.ReactNode
  section: string
}

export const TabSection = ({ icon, section }: Props) => (
  <div className={cn('flex items-center gap-sp-1 py-sp-2')}>
    {icon}
    <Heading level='h3' className=''>
      {section}
    </Heading>
  </div>
)
